/**
 *
 *@author xujinjiang
 *@date 2022/3/4 15:37
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { LocalStorageManager } from '@/db/LocalStorageManager';
import { LocalStorageKey } from '@/constant/LocalStorageKey';
import { HomeServiceImpl } from '@/service/HomeServiceImpl';
import { ObserverService } from '@/service/ObserverService';
import { CommonUtil } from '@/utils/CommonUtil';

export class CmsViewModel extends BaseViewModel {
  userId = ''; // 用户id

  created() {
    // 初始化观察者服务
    ObserverService.getInstance().init();
    let info: any;
    if (JSON.stringify(this.$route.query) != '{}') {
      info = this.$route.query;
      if (!info) {
        return;
      }
      LocalStorageManager.setItem(LocalStorageKey.token, info.token);
      this.getUserInfo(info).then();
      return;
    }
    const userInfo = LocalStorageManager.getUser();
    if (!userInfo) {
      console.error('localstorage 用户信息为空');
      return;
    }
    this.getUserInfo(userInfo).then();
  }

  /**
   * 获取用户信息
   */
  async getUserInfo(info: any) {
    try {
      this.user = await HomeServiceImpl.getInstance().getUserInfo(info.id);
      LocalStorageManager.setItem(LocalStorageKey.user, JSON.stringify(this.user.userInfo));
      ObserverService.getInstance().getUserObserver().next(this.user.userInfo);
    } catch (e: any) {
      console.error('获取用户信息失败：', e);
      CommonUtil.errorMessage(e.message + ', 请重新登录');
      // 获取用户信息接口报错时，清空本地信息
      LocalStorageManager.removeItem(LocalStorageKey.token);
      LocalStorageManager.removeItem(LocalStorageKey.user);
    }
  }

  async logout() {
    try {
      HomeServiceImpl.getInstance().logout().then(() => {
        console.debug('退出登录成功');
      });
    } catch (e: any) {
      console.debug('退出登录失败：', e);
      CommonUtil.errorMessage(e.message);
    }

    LocalStorageManager.removeItem(LocalStorageKey.user);
    LocalStorageManager.removeItem(LocalStorageKey.token);
    this.$router.push({path: '/'}).then();
    ObserverService.getInstance().getIsLoginObserver().next(false);
  }
}
